import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function fundingMethodEndpoints(builder) {
  return {
    getDistinctFundingMethod: builder.query({
      query: ({ query }) => ({
        url: `/member/funding/method/distinct${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(),
      providesTags: ["funding-method-distinct"]
    })
  };
}
export {
  fundingMethodEndpoints as default
};
